import classNames from 'classnames';
import Txt from '../Txt';
import View from '../View';
import FlexContainer from '../FlexContainer';
import styles from './TitledBlock.module.scss';

/**
 * TitledBlock
 *
 * @return {JSX.Element}
 */
const TitledBlock = ({ className, title, children }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.TitledBlock,
        className,
        `${TitledBlock.displayName}`
      )}
      column
      gapHalf
    >
      <View className={styles.Header}>
        <Txt className={styles.TxtTitle} xx bold>
          {title}
        </Txt>
      </View>
      <View className={styles.Body}>{children}</View>
    </FlexContainer>
  );
};

TitledBlock.displayName = 'TitledBlock';

export default TitledBlock;
